import { LocationContext } from 'app/containers/LocationProvider';

import React, { useContext, useEffect } from 'react';
import { Portal } from 'react-portal';
import { ConfigContext } from '../ConfigProvider';

const spbTemplate = require('./static/spb/spb-template.html');
const mskTemplate = require('./static/msk/msk-template.html');

const spbMarkup = { __html: spbTemplate };
const mskMarkup = { __html: mskTemplate };


function addCollapseListener(el: any) {
    let isCollapsed = true;

    const toggle = el.querySelector('[data-collapse-toggle]');
    const collapsed = el.querySelector('[data-collapse-collapsed]');
    const content = el.querySelector('[data-collapse-content]');

    toggle.addEventListener('click', () => {
        if (isCollapsed) {
            const h = content.scrollHeight;
            collapsed.style.height = `${h}px`;
            toggle.classList.add('question-item__toggle--expanded');

            isCollapsed = false;
        } else {
            collapsed.style.height = '0px';
            toggle.classList.remove('question-item__toggle--expanded');

            isCollapsed = true;
        }
    });
}

export default function initializeCollapse(selector: any) {
    document.querySelectorAll(selector).forEach((el) => {
        addCollapseListener(el);
    });
}


export function QuestionsAndFeedback() {
    const questionsNode = document.getElementById('like-5x2-page-portal');
    const { locationKey } = useContext(LocationContext);

    useEffect(() => {
        initializeCollapse('[data-collapse-item]');
    }, [locationKey]);


    if (!questionsNode) {
        return null;
    }

    return (
        <Portal node={questionsNode}>
            {['MSK', 'TUL', 'YAR', 'VLA', 'RYA', 'KLU', 'TVE']
                .includes(locationKey) && <div className="" dangerouslySetInnerHTML={mskMarkup} />}
            {locationKey === 'SPB' && <div className="" dangerouslySetInnerHTML={spbMarkup} />}
        </Portal>
    );
}


export const QuestionsAndFeedbackBlocks = React.memo(() => {
    const { pageId } = useContext(ConfigContext);
    if (!['grn', 'grn3'].includes(pageId)) {
        return null;
    }

    return <QuestionsAndFeedback />;
});
